/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 43f96b2d (Wed Dec  3 21:51:26 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { Address, AddressFromJSON, AddressToJSON } from './'

/**
 *
 * @export
 * @interface UserProfile
 */
export interface UserProfile {
  /**
   * The user ID assigned by the system when the user was first created.
   * @type number
   * @memberof UserProfile
   */
  id: number
  /**
   * The personal email the user registered with.
   * @type string
   * @memberof UserProfile
   */
  username: string
  /**
   * The first name provided by the user.
   * @type string
   * @memberof UserProfile
   */
  firstName?: string
  /**
   * The last name provided by the user.
   * @type string
   * @memberof UserProfile
   */
  lastName?: string
  /**
   * The phone number provided by the user.
   * @type string
   * @memberof UserProfile
   */
  phone?: string
  /**
   *
   * @type Address
   * @memberof UserProfile
   */
  address?: Address
  /**
   * An official, CC-assigned and -managed email address. This cannot be set or changed by most users.
   * @type string
   * @memberof UserProfile
   */
  email?: string
  /**
   * An optional business email address provided by the Director or Tutor, used for official communications such as team updates, event notifications and others.
   * @type string
   * @memberof UserProfile
   */
  businessEmail?: string
  /**
   * The user’s self-description.
   * @type string
   * @memberof UserProfile
   */
  bio?: string
  /**
   * Boolean indicating if the user has marked their profile as private.
   * @type boolean
   * @memberof UserProfile
   */
  isProfilePrivate?: boolean
  /**
   * Boolean indicating if the user has marked their login email as private.
   * @type boolean
   * @memberof UserProfile
   */
  isLoginEmailPrivate?: boolean
  /**
   * Boolean indicating if the user has marked their phone number as private.
   * @type boolean
   * @memberof UserProfile
   */
  isPhoneNumberPrivate?: boolean
  /**
   * The user’s country of residence
   * @type string
   * @memberof UserProfile
   */
  countryOfResidence?: string
  /**
   * The user’s country of citizenship
   * @type string
   * @memberof UserProfile
   */
  countryOfCitizenship?: string
}

export function UserProfileFromJSON(json: any): UserProfile {
  return UserProfileFromJSONTyped(json, false)
}

export function UserProfileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserProfile {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    username: json['username'],
    firstName: !exists(json, 'firstName') ? undefined : json['firstName'],
    lastName: !exists(json, 'lastName') ? undefined : json['lastName'],
    phone: !exists(json, 'phone') ? undefined : json['phone'],
    address: !exists(json, 'address')
      ? undefined
      : AddressFromJSON(json['address']),
    email: !exists(json, 'email') ? undefined : json['email'],
    businessEmail: !exists(json, 'businessEmail')
      ? undefined
      : json['businessEmail'],
    bio: !exists(json, 'bio') ? undefined : json['bio'],
    isProfilePrivate: !exists(json, 'isProfilePrivate')
      ? undefined
      : json['isProfilePrivate'],
    isLoginEmailPrivate: !exists(json, 'isLoginEmailPrivate')
      ? undefined
      : json['isLoginEmailPrivate'],
    isPhoneNumberPrivate: !exists(json, 'isPhoneNumberPrivate')
      ? undefined
      : json['isPhoneNumberPrivate'],
    countryOfResidence: !exists(json, 'countryOfResidence')
      ? undefined
      : json['countryOfResidence'],
    countryOfCitizenship: !exists(json, 'countryOfCitizenship')
      ? undefined
      : json['countryOfCitizenship'],
  }
}

export function UserProfileToJSON(value?: UserProfile | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    username: value.username,
    firstName: value.firstName,
    lastName: value.lastName,
    phone: value.phone,
    address: AddressToJSON(value.address),
    email: value.email,
    businessEmail: value.businessEmail,
    bio: value.bio,
    isProfilePrivate: value.isProfilePrivate,
    isLoginEmailPrivate: value.isLoginEmailPrivate,
    isPhoneNumberPrivate: value.isPhoneNumberPrivate,
    countryOfResidence: value.countryOfResidence,
    countryOfCitizenship: value.countryOfCitizenship,
  }
}
